import React from "react";

const writings = [
  {
    title: "First Look at TypeScript",
    date: "December 2023",
    href: "https://medium.com/@helinokcu/first-look-at-typescript-89e389b0fc0f",
  },
  {
    title: "Firebase Analytics with Expo: Events",
    date: "January 2024",
    href: "https://medium.com/@helinokcu/firebase-analytics-with-expo-events-38a1f6e4555f",
  },
];

function Writings() {
  return (
    <div className="py-14 border-b border-light-gray">
      <div className="flex items-center gap-3 mb-8">
        <span className="text-[11px] tracking-[0.12em] uppercase text-warm-gray font-semibold">
          Writings
        </span>
        <div className="flex-1 h-px bg-light-gray" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        {writings.map((w) => (
          <a
            key={w.title}
            href={w.href}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white border border-light-gray rounded-xl p-5 block transition-all duration-200 hover:border-navy hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(27,43,75,0.08)] no-underline"
          >
            <h3 className="font-display font-bold text-navy text-[14px] mb-1.5">
              {w.title}
            </h3>
            <p className="text-[11px] text-warm-gray">{w.date}</p>
            <span className="text-coral text-base mt-3 block">↗</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default Writings;
